import "bootstrap/dist/css/bootstrap.css";
import "styles/style.css";
import "styles/img.css";
import "styles/hamburgers.css";
import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom";
import { Route, Switch, BrowserRouter } from "react-router-dom";
import { Loading } from "components";
import PROJECTS from "projects";

const Home = lazy(() => import("components/Home"));
const Projects = lazy(() => import("components/Projects"));
const Project = lazy(() => import("components/Project"));
const Footer = lazy(() => import("components/Footer"));
const About = lazy(() => import("components/About"));
const NotFound = lazy(() => import("components/NotFound"));

const generateProjectRoutes = (projects) => {
  return projects.map((project, index) => (
    <Route
      key={index}
      exact
      path={`/projects/${project.name}`}
      component={() => <Project data={project} />}
    />
  ));
};

const App = () => (
  <BrowserRouter>
    <Suspense fallback={<Loading />}>
      <div style={{ height: "100%", paddingBottom: 20 }}>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/projects" component={Projects} />
          <Route path="/about" component={About} />
          {generateProjectRoutes(PROJECTS)}
          <Route path="*" component={NotFound} />
        </Switch>
        <Footer />
      </div>
    </Suspense>
  </BrowserRouter>
);

ReactDOM.render(<App />, document.querySelector("#root"));



// WEBPACK FOOTER //
// ./src/index.js